// 系统消息
export const UPDATE_MSG = 'UPDATE_MSG'
// 错误消息
export const UPDATE_ERROR_MSG = 'UPDATE_ERROR_MSG'
// 记录距离顶部位置
export const UPDATE_SCROLLTOP_POSITION = 'UPDATE_SCROLLTOP_POSITION'
// 加载状态
export const UPDATE_LOADING = 'UPDATE_LOADING'
// 标题
export const UPDATE_SHOW_TITLE = 'UPDATE_SHOW_TITLE'
// 显示画面方向
export const UPDATE_DIRECTION = 'UPDATE_DIRECTION'



// WEBPACK FOOTER //
// ./src/vuex/mutation-types.js